// NOTE: never expose backend secrets via VITE_* (they are embedded into the public bundle).
// api/v1/settings.ts
export const host = import.meta.env.VITE_API_HOST;

// НОВОЕ: получаем базовый URL без /v1 для прокси
export const getApiBaseUrl = () => {
  const url = import.meta.env.VITE_API_HOST || 'https://api.dev.myteacher.pro/v1';
  // Убираем /v1 если есть
  return url.replace(/\/v1$/, '');
};

// НОВОЕ: получаем только путь /v1
export const getApiPath = () => {
  const url = import.meta.env.VITE_API_HOST || 'https://api.dev.myteacher.pro/v1';
  // Возвращаем только путь после домена
  const match = url.match(/https?:\/\/[^\/]+(\/.*)$/);
  return match ? match[1] : '/v1';
};

// Для WebSocket
export const wsHost = import.meta.env.VITE_WS_HOST || 'wss://api.dev.myteacher.pro';

